<template>
  <div class="page-add page">
    <div class="pageTitleBox">
      <div class="boxNameL">新建出库</div>
      <div class="boxNameR">
        <el-button type="warning" @click="$router.back()" size="small"
          >返回</el-button
        >
      </div>
    </div>
    <div style="background-color: #fff; min-height: 500px">
      <el-form class="form">
        <el-row>
          <el-col :span="4">
            <el-form-item label="出库类型:" :label-width="'90px'">
              <el-select
                class="input"
                v-model="outOrderType"
                placeholder="请选择"
                size="small"
              >
                <el-option value="0" label="调拨出库" key="0"></el-option>
                <!-- $store.state.shopId == '5e9412e0b2bfbc089daerr14' -->
                <el-option
                  value="2"
                  label="报废出库"
                  key="2"
                 v-if="$buttonAuthority('cangku-chuku-baofei')"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="出库日期:" :label-width="'80px'">
              <el-date-picker
                disabled
                format="yyyy-MM-dd"
                value-format="timestamp"
                v-model="params.outDate"
                type="date"
                placeholder="选择日期"
                size="small"
                style="width: 140px"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="6" v-if="outOrderType === '0'">
            <el-form-item label="物品去向:" :label-width="'102px'" required>
              <el-select
                class="input"
                v-model="selectShopId"
                placeholder="请选择"
                size="small"
                style="width: 140px"
              >
                <el-option
                  :label="item.shop_name"
                  :value="item.shop_id"
                  v-for="item in userInfo.shops"
                  :key="item.shop_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="1" :offset="7"> </el-col>
        </el-row>
      </el-form>
      <div style="font-size: 14px; padding: 20px 16px">
        录入条码：
        <el-input
          style="width: 220px"
          placeholder="商品条码"
          v-model.lazy="scanningCodeInput"
          @keyup.enter.native="clickScanningCodeInput"
          size="small"
        ></el-input>
      </div>
      <!-- <el-form class="form">
				<el-row>
					<el-col :span="4" >
						<el-form-item label="出库商品:" :label-width="'90px'">
							<el-input style="width: 220px" placeholder="商品条码" v-model.lazy="scanningCodeInput" @keyup.enter.native="clickScanningCodeInput" size="small"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form> -->
      <el-table
        :data="tableData"
        style="width: 100%; margin-top: 10px"
        ref="table"
      >
        <el-table-column label="名称" prop="goodsName"> </el-table-column>
        <el-table-column label="品牌" prop="brand"> </el-table-column>
        <el-table-column label="规格">
          <template slot-scope="scope">
            <span>{{ scope.row.skuValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label="单位">
          <template slot-scope="scope">
            <span>{{ scope.row.unit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="num"> </el-table-column>
        <el-table-column type="expand" width="1">
          <template slot-scope="scope">
            <el-table v-show="false" :data="scope.row.goodsList">
              <el-table-column prop="goodsDosage"> </el-table-column>
            </el-table>
            <div
              style="display: inline-block"
              v-for="(item, index) in scope.row.goodsList"
              :key="index"
            >
              <el-tag
                style="margin: 5px"
                closable
                @close="deleteTwoGoods(scope.$index, index)"
              >
                {{ item.customCode }}
                <span style="margin-left: 10px; color: #8e71e4">
                  总次数
                  <span style="color: #8e71e4">{{ item.totaTimes }}</span>
                </span>
                <span style="margin-left: 10px; color: #fc6f6f">
                  已使用次数
                  <span style="color: #fc6f6f">{{ item.useTimes }}</span>
                </span>
                <span style="margin-left: 10px; color: #67c23a">
                  出库次数
                  <el-input
                    class="outinput"
                    type="text"
                    v-model="item.goodsDosage"
                    @input="changeNum(item)"
                  ></el-input>
                </span>
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-view"
              type="text"
              @click="toogleExpand(scope.row)"
              >查看条码</el-button
            >
            <el-button
              style="color: #ff4000"
              icon="el-icon-delete"
              type="text"
              @click="deleteGoods(scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="padding: 20px 0; background-color: #fff">
      <el-form>
        <el-row>
          <el-col :span="22">
            <el-form-item label="备注:" :label-width="'60px'">
              <el-input
                type="textarea"
                style="width: 500px"
                rows="4"
                v-model="params.remark"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"> </el-col>
        </el-row>
        <el-row>
          <el-col> </el-col>
          <el-col :span="2" :offset="22">
            <el-button type="warning" @click="submitForm" size="small"
              >提交</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import del from "../../util/del.js";
export default {
  data() {
    return {
      outOrderType: "0",
      selectShopId: "",
      params: {
        id: "",
        outDate: new Date().getTime(),
        remark: "",
      },

      scanningCodeInput: "",
      o: null,
      tableData: [],
      //记录调拨条码
      acceptanceParam: {
        code_list: [],
      },
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    curShopId() {
      return this.$store.state.shopId;
    },
  },
  mounted() {
    this.o = new del();
  },
  methods: {
    // 查找条码
    clickScanningCodeInput() {
      this.getScanData(this.scanningCodeInput);
      this.scanningCodeInput = "";
    },
    // 获取一物一码信息
    getScanData(code) {
      this.o.searchGoods(code).then(() => {
        //判断是否重复
        let isRepeat;
        isRepeat = this.acceptanceParam.code_list.some((item) => {
          return item == code;
        });
        if (isRepeat) {
          this.$message.error("条码重复");
          return;
        } else {
          //判断是否找到
          this.acceptanceParam.code_list.push(code);
        }
        let addState = this.o.addGoods();
        if (addState.type === "success") {
          console.log("添加成功");
        }
        for (let i = 0; i < this.o.arr.length; i++) {
          for (let a = 0; a < this.o.arr[i].goodsList.length; a++) {
            if (!this.o.arr[i].goodsList[a].goodsDosage) {
              this.o.arr[i].goodsList[a].goodsDosage = 1;
            }
          }
        }
        this.tableData = this.o.arr;
      });
    },
    // 100000247621
    // 提交
    submitForm() {
      if (this.outOrderType === "0") {
        if (this.selectShopId.length === 0) {
          this.$message({
            message: "请选择物品去向",
            type: "error",
          });
          return;
        }
      }
      if (this.tableData.length === 0) {
        this.$message({
          message: "请录入要出库的商品",
          type: "error",
        });
        return;
      }
      let outOrderItems = [];
      for (let i = 0; i < this.tableData.length; i++) {
        for (let a = 0; a < this.tableData[i].goodsList.length; a++) {
          let goods = this.tableData[i].goodsList[a];
          if (Number(goods.goodsDosage) > 0) {
            let item = {
              id: "",
              goodsId: goods.goodsId,
              goodsName: goods.goodsName,
              model: goods.model,
              skus: goods.skus,
              unit: goods.unit,
              unitId: goods.unitId,
              customCode: goods.customCode,
              totaTimes: goods.totaTimes,
              useTimes: goods.useTimes,
              count: Number(goods.goodsDosage),
              goodsType: goods.goodsType,
            };
            outOrderItems.push(item);
          } else {
            this.$message({
              message: goods.customCode + " 条码出库量错误",
              type: "error",
            });
            return;
          }
        }
      }
      let params = {
        id: "",
        outDate: this.params.outDate.toString(),
        outUserId: this.userInfo.uid,
        outUserName: this.userInfo.uName,
        outOrderFile: "",
        checkOrderFile: "",
        transfersOrderFile: "",
        remark: this.params.remark,
        outOrderItems: outOrderItems,
      };
      console.log(params, "params");

      this.$confirm(
        "本次出库" +
          params.outOrderItems.length +
          "个条码。提交后将自动申请通过，请谨慎操作。确定提交?",
        "提示",
        {
          confirmButtonText: "确定提交",
          cancelButtonText: "我再核对一下",
          type: "warning",
        }
      ).then(() => {
        let loading = this.$loading();
        let http;
        if (this.outOrderType === "0") {
          if (this.selectShopId.length === 0) {
            this.$message({
              message: "请选择物品去向",
              type: "error",
            });
            return;
          }
          params.transferOutShopId = this.curShopId;
          params.transferOutShopName = this.$public.getShopNameById(
            this.curShopId
          );
          params.transferInShopId = this.selectShopId;
          params.transferInShopName = this.$public.getShopNameById(
            this.selectShopId
          );
          http = this.$http.post(
            process.env.VUE_APP_Url3 +
              "api/Warehouse/OutOrder/shop/transferout",
            params
          );
        } else if (this.outOrderType === "1") {
          params.currentShopId = this.curShopId;
          params.currentShopName = this.$public.getShopNameById(this.curShopId);
          http = this.$http.post(
            process.env.VUE_APP_Url3 + "api/Warehouse/OutOrder/shop/lossout",
            params
          );
        } else if (this.outOrderType === "2") {
          params.currentShopId = this.curShopId;
          params.currentShopName = this.$public.getShopNameById(this.curShopId);
          http = this.$http.post(
            process.env.VUE_APP_Url3 + "api/Warehouse/OutOrder/shop/scrap",
            params
          );
        } else if (this.outOrderType === "3") {
          params.useShopId = this.curShopId;
          params.useShopName = this.$public.getShopNameById(this.curShopId);
          http = this.$http.post(
            process.env.VUE_APP_Url3 + "api/Warehouse/OutOrder/shop/SelfUse",
            params
          );
        }
        http.then((res) => {
          loading.close();
          if (res.code == 0) {
            if (res.code == 0) {
              this.$router.back();
            }
          }
        });
      });
    },

    changeNum(item) {
      item.goodsDosage = this.replaceGoodsDosage(item.goodsDosage);
      if (item.goodsDosage > item.onlyTimes) {
        this.$set(item, "goodsDosage", item.onlyTimes);
        this.$message({
          message: "最大出库量为：" + item.onlyTimes,
          type: "error",
        });
        item.goodsDosage = item.onlyTimes;
      }
    },
    replaceGoodsDosage(value) {
      //先把非数字的都替换掉，除了数字和.
      value = value.replace(/[^\d.]/g, "");
      //必须保证第一个为数字而不是.
      value = value.replace(/^\./g, "");
      //保证只有出现一个.而没有多个.
      value = value.replace(/\.{2,}/g, ".");
      //保证.只出现一次，而不能出现两次以上
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      return value;
    },
    // 删除添加的商品
    deleteGoods(index) {
      this.$confirm("确认删除该商品下的所有条码吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.o.del([index, 0]);
        this.tableData = this.o.arr;
      });
    },
    deleteTwoGoods(rowIndex, index) {
      this.$confirm("确认删除此条码吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.o.del([rowIndex, index], true);
        this.tableData = this.o.arr;
      });
    },
    toogleExpand(row) {
      let $table = this.$refs.table;
      this.tableData.map((item) => {
        if (row.skus != item.skus) {
          $table.toggleRowExpansion(item, false);
        }
      });
      $table.toggleRowExpansion(row);
    },
  },
};
</script>
<style lang="scss">
.page-add {
  .pageTitleBox {
  }
  .form {
    padding: 16px 0 0 0;
    .el-form-item {
      margin-bottom: 0;
      .el-form-item__label {
        color: $fontColor;
      }
    }
  }
  .wrapper {
    .tit {
      font-size: 16px;
      margin-bottom: 28px;
      background-color: #f5f5f5;
      height: 40px;
      line-height: 40px;
      border-radius: 3px;

      .name {
        margin-left: 20px;
      }

      .day {
        color: #666;
      }
    }
  }
}

.row-expand-cove .el-table__expand-icon {
  display: none;
}

.el-table .sort-caret.descending {
  border-top-color: #000;
}

.el-table .sort-caret.ascending {
  border-bottom-color: #000;
}
.outinput {
  border: none;
  border-bottom: 1px solid #333;
  width: 35px;
  height: 27px;
  margin-right: 10px;
  .el-input__inner {
    text-align: center;
    padding: 2px;
    background: none;
    border: 0;
    height: 25px;
    line-height: 25px;
  }
}
</style>
